import React from "react";
import { useTranslation, LANGUAGES } from "@/context/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useTranslation();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher-trigger"
        className={`inline-flex items-center gap-1.5 rounded-full border border-stone-200 bg-white hover:bg-stone-50 ${
          compact ? "px-2.5 h-8 text-xs" : "px-3 h-9 text-sm"
        } font-medium text-stone-700 transition`}
        aria-label="Select language"
      >
        <Globe className="w-3.5 h-3.5 text-green-700" />
        <span className="hidden sm:inline">{current.native}</span>
        <span className="sm:hidden uppercase">{current.code}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-xl min-w-[160px]">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <div>
              <div className="font-medium">{l.native}</div>
              <div className="text-[11px] text-stone-500">{l.label}</div>
            </div>
            {lang === l.code ? (
              <Check className="w-4 h-4 text-green-600" />
            ) : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
